<template>
	<a-modal title="操作" style="top: 20px" :width="800" v-model="visible" :confirmLoading="confirmLoading" @ok="handleSubmit">
		<a-form :form="form">
			<a-form-item style="display: none">
				<a-input v-decorator="['deptId']" />
			</a-form-item>

			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级部门">
				<a-tree-select v-decorator="['parentId', { initialValue: '0', rules: [{ required: true, message: '请选择上级部门' }] }]"
				 :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }" :treeData="depts" placeholder="上级部门"
				 treeDefaultExpandAll>
				</a-tree-select>
			</a-form-item>

			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门名称">
				<a-input v-decorator="['deptName', { rules: [{ required: true, message: '请输入部门名称' }] }]" placeholder="起一个名字" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否是公司">
				<a-select v-decorator="['isCompany', { rules: [{ required: true, message: '请选择是否是公司' }] }]" placeholder="是否是公司">
					<a-select-option :value="0">否</a-select-option>
					<a-select-option :value="1">是</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="显示顺序">
				<a-input v-decorator="['orderNum', { rules: [{ required: true, message: '请输入显示顺序' }] }]" placeholder="显示顺序" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人">
				<a-tree-select v-decorator="['leaderDept']" style="float: left; width: 50%" :treeData="deptTree" allowClear
				 placeholder="请选择负责人公司"  @change="leaderid($event)">
				</a-tree-select>
				<a-select v-decorator="['leader']" allowClear style="float: left; width: 50%" @change="leadername($event)"
				 placeholder="请选择负责人" show-search :filter-option="filterOption" >
					<a-select-option :key="index" v-for="(item, index) in leaderList" :value="item.userName">
						{{ item.userName }}
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话">
				<a-input v-decorator="['phone']" placeholder="电话" />
			</a-form-item>
			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="邮箱">
				<a-input v-decorator="['email']" placeholder="邮箱" />
			</a-form-item>

			<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
				<a-select v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]">
					<a-select-option :value="'0'">正常</a-select-option>
					<a-select-option :value="'1'">停用</a-select-option>
				</a-select>
			</a-form-item>
		</a-form>
	</a-modal>
</template>
<script>
	import {
		getDeptList,
		getUserList,
		saveDept,
		getDeptListEnable
	} from '@/api/system'
	import pick from 'lodash.pick'
	export default {
		name: 'DeptModal',
		components: {},
		data() {
			return {
				status: '',
				description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
				visible: false,
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 5,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				depts: [{
					key: '0',
					value: '0',
					title: '无',
				}, ],
				dataList: [],
				userId: '',
				deptTree: [],
				leaderList: [],
				mdl: {},
				// list:[],
				confirmLoading: false,
				form: this.$form.createForm(this),
			}
		},
		beforeCreate() {},
		created() {
			getDeptList().then((res) => {
				this.buildtree(res.rows, this.depts, 0)
				// this.list=res.rows
			})
			getDeptListEnable().then((res) => {
				const data = res.rows
				if (data.length > 0) {
					const min = Math.min(...data.map((m) => m.parentId))
					this.buildtree2(data, this.deptTree, min)
					this.expandedKeys = data.map((m) => m.parentId)
					this.dataList = data.map((m) => {
						return {
							key: m.deptId,
							title: m.deptName,
						}
					})
				}
			})
		},
		methods: {
			 filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			leadername(typeId) {
				this.leaderList.forEach((item) => {
					if (item.userName == typeId) {
						this.userId = item.userId
					}
				})
			},
			leaderid(depaId) {
				this.form.setFieldsValue({
					leader: '',
				})
				getUserList({
					deptId: depaId,
				}).then((res) => {
					for(var i = res.rows.length - 1; i>=0; i-- ) {
						if(res.rows[i].status == 1) {
							res.rows.splice(i, 1)
						}

					}
					this.leaderList = res.rows
				})
			},
			add(parentId) {
				this.status = 'add'
				this.form.resetFields()
				this.edit({
					parentId: parentId || 0,
				})
			},
			edit(record) {
				this.status = 'edit'
				this.mdl = Object.assign({}, record)
				console.log(this.mdl,12)
				this.visible = true
				this.$nextTick(() => {
					this.mdl.parentId += ''
					this.leaderid(this.mdl.leaderDept)
					this.form.setFieldsValue(
						pick(this.mdl, [
							'deptId',
							'isCompany',
							'parentId',
							'leader',
							'leaderDept',
							'phone',
							'status',
							'email',
							'orderNum',
							'deptName',
						])
					)
					// this.list.forEach((item,index)=>{
					// 	this.form.setFieldsValue({
					// 	   isCompany: this.instrumentMap[item.isCompany]
					// 	 })
					// })
					// this.form.setFieldsValue({ ...record })
				})
			},
			buildtree(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId + '',
							title: item.deptName,
							children: [],
						}
						this.buildtree(list, child.children, item.deptId)
						arr.push(child)
					}
				})
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			handleSubmit(e) {
				e.preventDefault()
				this.form.validateFields((err, values) => {
					if (!err) {
						console.log('Received values of form: ', values)
						this.visible = false
						this.confirmLoading = true
						if(!this.userId){
							this.leadername(values['leader'])
						}
						values['leaderId'] = this.userId
						saveDept(values)
							.then((res) => {
								if (res.code === 200) {
									this.$message.success('保存成功')
									this.$emit('ok')
									this.visible = false
								} else {
									this.$message.success(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
							.finally(() => {
								this.confirmLoading = false
							})
					}
				})
			},
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
